///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { CustomerDTO } from '../../../generated/shared-types.model';
import { GtthCustomerService } from '../../../services/customer/customer.service';
import { Store } from '@ngrx/store';
import { blockCustomer } from '../../store/customer-config.actions';
import { PreloaderService } from '../../../services/preloader.service';
import { finalize } from 'rxjs';

@Component({
    selector: 'winde-customer-block-dialog',
    templateUrl: './block-customer-dialog.component.html',
    standalone: false
})
export class BlockCustomerDialogComponent {
    public customer: CustomerDTO = this.data.payload;

    constructor(
        private readonly customerService: GtthCustomerService,
        private readonly preloaderService: PreloaderService,
        private readonly store: Store,
        public dialogRef: MatDialogRef<BlockCustomerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { payload: CustomerDTO }
    ) {}

    confirmBlock(customer: CustomerDTO) {
        customer.blocked = !customer.blocked;
        this.preloaderService.show();

        this.customerService
            .blockCustomer(customer)
            .pipe(finalize(() => this.preloaderService.hide()))
            .subscribe(() => {
                this.dialogRef.close(true);
                this.store.dispatch(blockCustomer({ id: customer.id }));
            });
    }
}
